import $ from 'jquery';
import Swiper, { Navigation } from 'swiper';
Swiper.use([ Navigation ]);

export default class SbsMediaHighlight {
    constructor() {
        if($('.js-sbs-media-highlight').length) {
            const $slider = $('.js-sbs-media-highlight');

            const sbsMediaHighlight = new Swiper($slider[0], {
                autoHeight: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                slidesPerView: 1,
                speed: 300
            });

            sbsMediaHighlight.init();
        };
    };
};
